define.alias("shared/components/shared/mobile/drawer/carousel-card", "calendar/components/shared/mobile/drawer/carousel-card");